import VN from "../components/VN";
import { useContext, useState, useEffect } from "react";
import { UserDataContext } from "../components/UserDataContext";
import { Container, Table } from "react-bootstrap";
import { apiRequest } from "../components/Config";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import { TextField } from "@mui/material";
import Alerts from "../components/Alerts";
import { Row } from "react-bootstrap";
import { marginBottom } from "../App";

export default function Projects() {
  const { userData } = useContext(UserDataContext);
  const [projects, setProjects] = useState([]);
  const [newProject, setNewProject] = useState("");
  const [showAddProject, setShowAddProject] = useState(false);
  const [apiResponse, setApiResponse] = useState({});
  const [showApiResponse, setShowApiResponse] = useState(false);
  useEffect(() => {
    if (userData) {
      fetchData();
    }
  }, [userData]);

  const handleShowAddProject = () => {
    setShowAddProject(!showAddProject);
  };

  const fetchData = async () => {
    try {
      const response = await apiRequest("filesprojects", "GET");
      //console.log("Projects: ", response);
      if (Array.isArray(response)) {
        setProjects(response);
      } else {
        setProjects([]);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const values = {};
  const handleAddProject = async (newProject) => {
    values["project"] = newProject;
    setNewProject(newProject);
    console.log("New project: ", values);
    try {
      const response = await apiRequest(`insertproject`, "POST", values);
      console.log("response project: ", response);
      if (response.error_msg === 200) {
        setShowApiResponse(true);
        setApiResponse({
          title: "Informacja",
          severity: "success",
          info: "Projekt dodany!",
        });
        await fetchData();
      }
      if (response.error_msg === 502) {
        setShowApiResponse(true);
        setApiResponse({
          title: "Informacja",
          severity: "error",
          info: "Ten projekt już istnieje!",
        });
      }
      if (response.error_msg === 503) {
        setShowApiResponse(true);
        setApiResponse({
          title: "Informacja",
          severity: "warning",
          info: "Nie wprowadzono nazwy projektu...",
        });
      }
    } catch (error) {
      setShowApiResponse(true);
      setApiResponse({
        title: "Uwaga",
        severity: "error",
        info: "Nie udało się zaktualizować!",
      });
      console.error("There was an error editing the user!", error);
    }
  };
  return (
    <div>
      <VN userData={userData} />
      {showApiResponse && (
        <Row style={{ marginBottom }}>
          <Alerts data={apiResponse} />
        </Row>
      )}
      <h1>Projekty</h1>
      <Container>
        <div className="table-responsive">
          <Table bordered hover>
            <thead>
              <tr>
                <th className="td-centered">ID</th>
                <th className="td-centered">Projekt</th>
                <th className="td-centered">Aktywny</th>
              </tr>
            </thead>
            <tbody>
              {projects.map((cat, index) => (
                <tr key={cat.id}>
                  <td className="td-centered">{index + 1}</td>
                  <td>{cat.project}</td>
                  <td className="td-centered">{cat.active ? "✅" : "❌"}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <Button onClick={handleShowAddProject}>
          Dodaj projekt
          <AddIcon />
        </Button>
        {showAddProject && (
          <>
            <h6>Dodanie nowego projektu</h6>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleAddProject(newProject);
                setNewProject("");
              }}
            >
              <TextField
                name="project"
                label="Nowy projekt"
                variant="outlined"
                value={newProject}
                onChange={(e) => setNewProject(e.target.value)}
                fullWidth
              />
              <Button type="submit">Zapisz</Button>
            </form>
          </>
        )}
      </Container>
    </div>
  );
}
